<template>
  <div class="col-12 mb-primary">
    <div class="card card-with-shadow border-0 h-100">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <div class="row" v-if="message.length > 0">
          <div
            class="col-md-12 col-12 mb-3"
            v-for="(msg, index) in message"
            :key="index"
            v-if="msg.user_id == userRole.id || userRole.role == 'App Admin'"
          >
            <div class="media-body d-flex justify-content-start mb-1">
              <!-- {{ $t("to") }} -->

              <span class="ml-1">
                <div class="media d-flex align-items-start">
                  <app-avatar
                    class="mr-1"
                    avatar-class="avatars-w-20"
                    :img="getAppUrl('images/avatar-demo.jpg')"
                    :alt-text="$t('not_found')"
                  />
                  <div class="media-body">
                    {{ msg.user.full_name }}
                  </div>
                </div>
              </span>
            </div>
            <div class="text-muted d-flex align-items-start mb-2 mt-2">
              <div class="media-body d-flex justify-content-start ml-4">
                <small v-if="msg.status == 0">
                  {{ msg.start_date }} To {{ msg.due_date }} 
                    <span :style="dueDate(msg.due_date) == 0 ? {color:'red'} : {color:'green'}">{{dueDate(msg.due_date) == 1 ? 
                      `(${dueDate(msg.due_date)} Day Left)` : dueDate(msg.due_date) == 0 ? `(Due Date Exceeded)` : 
                      `(${dueDate(msg.due_date)} Days Left)`  }}
                    </span>
                </small>
                <small v-else class="font-weight-bold">
                  <!-- Endorsed At: {{new Date('Y-m-d',msg.updated_at).getDate()}} -->
                     Endorsed At: {{new Date(msg.updated_at).toLocaleString()}}
                </small>
              </div>
            </div>
            <div class="col-12">
              <div class="col-6">
                <app-input
                    id="text_title"
                    type="textarea"
                    :read-only="true"
                    v-model="msg.message"/>
              </div>

              <div class="col-6">
                <div class="el-image-viewer__canvas">
                  <img
                      ref="img"
                      class="el-image-viewer__img"
                      :key="url"
                      :src="msg.signature"
                      style="widh:100px;height:100px">
                </div>
              </div>
            </div>



              <!-- <p>{{ msg.message }}</p> -->
          </div>
        </div>
        <div v-else>
          <app-empty-data-block :message="$t('nothing_to_show_message')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { MY_TASK_SHOW } from "../../../../Config/ApiUrl";
import { axiosGet } from "../../../../Helpers/AxiosHelper";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  name: "mytaskmodal",
  mixins: [FormMixin],
  data() {
    return {
      message: [],
      preloader: false,
      due_date: 0,
      signature: '',
    };
  },

  methods: {
    getTask() {
      let id = this.$attrs["props"];
      axiosGet(MY_TASK_SHOW + "/" + id.id)
      .then((response) => {
          this.message = response.data.task[0].task_endorsement_request;
          this.signature = response.data.task[0].task_endorsement;
            this.message.filter((msg,index) =>{
                this.signature.filter((sign) =>{
                 if(msg.user_id == sign.endorsed_by)
                 {
                   this.message[index]['signature'] = sign.signature;
                 }
                 else {
                   this.message[index]['signature'] = '';
                 }
              });
            });
        })
        .catch((error) => {
          
        });
    },
    dueDate(due_date) {
      const date1 = new Date(due_date);
      const date2 = new Date();
      const oneDay = 1000 * 60 * 60 * 24;
      const diffInTime = date1.getTime() - date2.getTime();
      const diffInDays = Math.round(diffInTime / oneDay);
      return diffInDays;
    }
  },
  mounted() {
    this.getTask();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
